import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8305daa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "litigation-application-info local-main-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LitigationEdit = _resolveComponent("LitigationEdit")!
  const _component_ApplicationInfo = _resolveComponent("ApplicationInfo")!
  const _component_ContractArea = _resolveComponent("ContractArea")!
  const _component_CollectionList = _resolveComponent("CollectionList")!
  const _component_FlowList = _resolveComponent("FlowList")!
  const _component_AuctionList = _resolveComponent("AuctionList")!
  const _component_MediateList = _resolveComponent("MediateList")!
  const _component_OperateList = _resolveComponent("OperateList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LitigationEdit, {
      ref: "litigation-edit",
      mainData: _ctx.mainData,
      flow: _ctx.flow.data,
      next: _ctx.next,
      payload: { overdueRecordId: _ctx.currentOverdueRecordId, applyLitigationId: _ctx.applyLitigationId, },
      disabled: _ctx.isFinished,
      onBack: _ctx.onBack,
      onReload: _ctx.onReload
    }, null, 8, ["mainData", "flow", "next", "payload", "disabled", "onBack", "onReload"]),
    (_ctx.applyLitigationId)
      ? (_openBlock(), _createBlock(_component_ApplicationInfo, {
          key: 0,
          id: _ctx.applyLitigationId
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ContractArea, {
      value: _ctx.currentOverdueRecordId,
      onLoaded: _ctx.onContractLoad
    }, null, 8, ["value", "onLoaded"]),
    (_ctx.id && _ctx.process >= 50)
      ? (_openBlock(), _createBlock(_component_CollectionList, {
          key: 1,
          id: _ctx.id,
          unOperate: _ctx.isFinished
        }, null, 8, ["id", "unOperate"]))
      : _createCommentVNode("", true),
    (_ctx.id && _ctx.process >= 50)
      ? (_openBlock(), _createBlock(_component_FlowList, {
          key: 2,
          id: _ctx.id,
          unOperate: _ctx.isFinished
        }, null, 8, ["id", "unOperate"]))
      : _createCommentVNode("", true),
    (_ctx.id && _ctx.process >= 50)
      ? (_openBlock(), _createBlock(_component_AuctionList, {
          key: 3,
          id: _ctx.id,
          unOperate: _ctx.isFinished
        }, null, 8, ["id", "unOperate"]))
      : _createCommentVNode("", true),
    (_ctx.id && _ctx.process >= 10)
      ? (_openBlock(), _createBlock(_component_MediateList, {
          key: 4,
          id: _ctx.id,
          overdueRecord: _ctx.overdueRecord,
          logRecord: _ctx.detail,
          unOperate: _ctx.isFinished
        }, null, 8, ["id", "overdueRecord", "logRecord", "unOperate"]))
      : _createCommentVNode("", true),
    (_ctx.id && _ctx.process >= 10)
      ? (_openBlock(), _createBlock(_component_OperateList, {
          key: 5,
          id: _ctx.id,
          overdueRecord: _ctx.overdueRecord
        }, null, 8, ["id", "overdueRecord"]))
      : _createCommentVNode("", true)
  ]))
}